import { joinUrl, appendSlash } from '@xlearn/async-toolbox'
export { joinUrl } from '@xlearn/async-toolbox'

export function walkObjectAndReplaceBasePaths<T>(obj: T, aspectBasePath: string = ''): T {
  if (Array.isArray(obj)) {
    let arrayResult: any = [];
    for (let i = 0; i < obj.length; i++) {
      const key = i;
      const value = obj[i];
      arrayResult = handleKeyValueInObject(key, value, arrayResult, aspectBasePath);
    }

    return arrayResult;
  }

  let objectResult: any = {};
  Object.entries(obj).forEach(([key, value]) => {
    objectResult = handleKeyValueInObject(key, value, objectResult, aspectBasePath);
  });

  return objectResult;
};

function handleKeyValueInObject(key: string | number, value: any, result: any, aspectBasePath: string = '') {
  if (value && typeof value === 'object') {
    result[key] = walkObjectAndReplaceBasePaths(value, aspectBasePath);
  } else if (typeof value === 'string') {

    if (value.includes('basePath')) {
      //console.error('BASEPATH in content', value)
    }
    
    result[key] = replaceBasePathInContent(aspectBasePath)(value);
  } else {
    result[key] = value;
  }

  return result;
};

// export function replaceBasePathInContent(content: string, basePath: string): string {
//   const courseBasePath: string = process.env.VUE_APP_COURSE_BASE_PATH;

//   const url = appendSlash(joinUrl(courseBasePath, basePath))
  
//   return content
//     .replace(/\$\{basePath\}\//g, url);
// };

// TODO: Review and possibly refactor to a class?
export function replaceBasePathInContent(basePath: string) {

  return (content: string) => {

    const url = appendSlash(withBaseUrl(basePath))
    
    return content
      .replace(/\$\{basePath\}/g, url);
  }  
};

export function withBaseUrl(...path: string[]) {
  const courseBasePath: string = process.env.VUE_APP_COURSE_BASE_PATH;
  return joinUrl(courseBasePath, ...path)
}
